<template>
  <header>
    <!-- <div class="header-container" id="topic_top">
      <div class="header-main">
        <div class="logo">
          <h1>学科知识库</h1>
          <span>高校图书馆</span>
        </div>
        <div class="user-controls">
          <div class="search-and-subject">
            <div class="subject-search-box">
              <el-input
                placeholder="请输入题名、关键词进行检索"
                v-model="subjectSearchKeyword"
                @keyup.enter.native="handleSubjectSearch"
                class="subject-search-input"
                size="small"
                maxlength="200"
                @input="getKeywordData"
                @focus="showSearchInput"
                @blur="hideSearchInput"
              >
                <template slot="suffix">
                  <i
                    v-if="subjectSearchKeyword.trim()"
                    class="el-input__icon el-icon-circle-close clear-icon"
                    @click="clearSubjectSearch"
                  ></i>
                  <i
                    class="el-input__icon el-icon-search search-icon"
                    @click="handleSubjectSearch"
                  ></i>
                </template>
              </el-input>-->
    <!-- 在输入框下方添加联想词弹出层 -->
    <!-- </div>
            <div class="search-lianxiang" v-if="searchFlag" @click.stop>
              <ul>
                <li
                  class="line1"
                  v-for="(item, index) in keywordDataList"
                  :key="index"
                  @click="toSearchKeyword(index)"
                  v-safe-html="item.suggestionWord"
                ></li>
              </ul>
            </div>

          </div>
          <div class="user-profile" @click="toMine" v-if="info && !info.ipUser">
            <i class="el-icon-user-solid"></i>个人信息
          </div>-->
    <!-- <div class="user-profile"  @click="toLogin" v-if="!info || info.ipUser">
            <i class="el-icon-user-solid"></i>请登录
          </div> -->
    <!--<div class="user-profile" @click="toHome">
            <i class="el-icon-s-home"></i>回到主页
          </div>
        </div>
        <div v-if="ipWarning" class="ip-warning">
          {{ ipWarning }}
        </div>
      </div>
    </div> -->
    <div class="subject-nav">
      <div class="container">
        <div class="subject-tabs">
          <div class="subject-tab" :class="{ checked: tabIndex == 1 }" @click="toRouter(1)">首页概览</div>
          <div class="subject-tab" :class="{ checked: tabIndex == 2 }" @click="toRouter(2)">学科期刊</div>
          <div class="subject-tab" :class="{ checked: tabIndex == 3 }" @click="toRouter(3)">学科资讯</div>
          <div class="subject-tab" :class="{ checked: tabIndex == 4 }" @click="toRouter(4)">学科学者</div>
          <div class="subject-tab" :class="{ checked: tabIndex == 5 }" @click="toRouter(5)">学科话题</div>
          <div class="subject-tab" :class="{ checked: tabIndex == 6 }" @click="toRouter(6)">学科研究文献</div>
          <!-- <div class="subject-tab" :class="{ checked: tabIndex == 7 }" @click="toRouter(7)">学术动态</div> -->
        </div>
        <el-tooltip :content="defaultCheckedName" placement="bottom" :disabled="!isSubjectNameTruncated">
          <div class="subject-selector" @click="showDialog" ref="subjectSelector">
            <span class="subject-name" ref="subjectName">{{ defaultCheckedName }}</span>
            <span class="subject-btn"><i class="el-icon-sort"></i>切换学科 </span>
          </div>
        </el-tooltip>
      </div>
    </div>
    <el-dialog
      title="选择学科"
      :visible.sync="open"
      width="min(92vw, 640px)"
      custom-class="subject-dialog"
      :close-on-click-modal="false"
    >
      <div class="change-cn">
        <el-switch @change="changeCn" v-model="cnFlag" active-text="中文" inactive-text="English"> </el-switch>
        <el-input placeholder="请输入学科名称" v-model="name" clearable @keyup.enter.native="searchTree()">
          <el-button slot="append" type="primary" icon="el-icon-search" @click="searchTree"></el-button>
        </el-input>
      </div>
      <div class="dialog-tree"><el-tree ref="tree" :data="treeData" :props="defaultProps" :highlight-current="true" :default-expanded-keys="defaultExpandedKeys" check-strictly accordion show-checkbox node-key="id" @check="handleNodeClick" @node-click="handleRowClick" :check-on-click-node="false"></el-tree>、</div>
    </el-dialog>
  </header>
</template>

<script>
import { EventBus } from "../utils/eventBus";
export default {
  name: "headers",
  data() {
    return {
      info: null,
      tabIndex: 1,
      name: "",
      open: false,
      treeData: [],
      defaultProps: {
        label: "label", // 替换标签字段别名
        children: "childrenList", // 替换子节点字段别名
      },

      defaultCheckedName: "",
      defaultCheckedId: "",
      defaultExpandedKeys: [],
      currentNodeKey: null,
      cnFlag: false,
      subjectSearchKeyword: "", // 学科检索框关键词
      isSubjectNameTruncated: false, // 学科名称是否被截断
      searchFlag: false, // 控制联想词列表显示隐藏
      keywordDataList: [], // 存储联想词数据
      ipUser: false,
      ipWarning: localStorage.getItem("ipWarning") || "",
    };
  },
  watch: {
    $route: {
      handler(val) {
        if (val.name == "subjectGateway" || val.name == "list") {
          this.tabIndex = 1;
        }
        if (val.name == "journal") {
          this.tabIndex = 2;
        }
        if (val.name == "news") {
          this.tabIndex = 3;
        }
        if (val.name == "author") {
          this.tabIndex = 4;
        }
        if (val.name == "topic") {
          this.tabIndex = 5;
        }
        if (val.name == "literature") {
          this.tabIndex = 6;
        }
        if (val.name == "dynamic") {
          this.tabIndex = 7;
        }
      },
      // 深度观察监听
      deep: true,
      immediate: true,
    },
    // 监听学科检索关键词变化，自动保存到sessionStorage
    subjectSearchKeyword(val) {
      if (val) {
        sessionStorage.setItem("subjectSearchKeyword", val);
      } else {
        sessionStorage.removeItem("subjectSearchKeyword");
      }
    },
  },
  mounted() {
    if (sessionStorage.getItem("cnFlag")) {
      this.cnFlag = JSON.parse(sessionStorage.getItem("cnFlag"));
    }
    // 页面刷新时清空检索词
    this.subjectSearchKeyword = "";
    sessionStorage.removeItem("subjectSearchKeyword");
    sessionStorage.removeItem("subjectSearchInfo");
    sessionStorage.removeItem("subjectNodes");

    this.getInfo();

    this.getSubjectList();
  },
  updated() {
    // 检查学科名称是否被截断
    this.checkSubjectNameTruncation();
  },

  methods: {
    getInfo() {
      this.$http({
        url: "api/v1/user/info",
        method: "POST",
      }).then(res => {
        this.info = res.data;
        this.ipUser = res.data.ipUser;
      });
    },

    searchTree() {
      this.searchTreeFlag = true;
      // this.defaultCheckedId = "";
      // this.defaultCheckedName = "";
      // sessionStorage.removeItem("subjectNodes");

      this.getSubjectList();
    },
    getSubjectList() {
      this.$http({
        url: "api/v1/subject/gateway/topic/tree?name=" + this.name.trim() + "&isZh=" + this.cnFlag,
        method: "GET",
      }).then(res => {
        this.treeData = res.data;
        // 树结构数据处理  为每个节点添加一个label属性  这个label 根据切换中英文 记录不同的name
        this.treeData.forEach(element => {
          this.$set(element, "label", this.cnFlag ? element.cnName : element.name);
          // 一级学科禁用勾选
          this.$set(element, "disabled", true);
          if (element.childrenList && element.childrenList.length > 0) {
            element.childrenList.forEach(item => {
              this.$set(item, "label", this.cnFlag ? item.cnName : item.name);
              // 二级学科允许勾选
              this.$set(item, "disabled", false);
            });
          }
        });
        this.getSubjectAgo();
        // this.defaultCheckedId = sessionStorage.getItem("subjectNodes") ? JSON.parse(sessionStorage.getItem("subjectNodes")).id : "";
        // if (this.treeData.length > 0) {
        //   if (!sessionStorage.getItem("subjectNodes")) {
        //     // 要求刷新也要保持原来的状态
        //     this.defaultCheckedName = this.treeData[0].childrenList[0].label;
        //     this.defaultCheckedId = this.treeData[0].childrenList[0].id;
        //     sessionStorage.setItem("subjectNodes", JSON.stringify(this.treeData[0].childrenList[0]));
        //   } else {
        //     this.defaultCheckedName = JSON.parse(sessionStorage.getItem("subjectNodes")).label;
        //     this.defaultCheckedId = JSON.parse(sessionStorage.getItem("subjectNodes")).id;
        //   }
        // 搜索后默认第一个节点选中
        // if (this.searchTreeFlag && this.treeData.length > 0) {
        //   this.defaultCheckedNodes();
        //   let data = JSON.parse(sessionStorage.getItem("subjectNodes"));
        //   this.handleNodeClick(data);
        // }
        // }
      });
    },
    getSubjectAgo() {
      this.$http({
        url: "api/v1/subject/gateway/click/ago",
        method: "get",
      }).then(res => {
        if (res.data) {
          this.defaultUserNode = this.findNodeById(this.treeData, res.data);

          this.defaultCheckedName = this.defaultUserNode.label;
          this.defaultCheckedId = this.defaultUserNode.id;
        } else {
          this.defaultUserNode = this.treeData[0].childrenList[0];
          this.defaultCheckedName = this.treeData[0].childrenList[0].label;
          this.defaultCheckedId = this.treeData[0].childrenList[0].id;
        }
        const expandedId = this.defaultUserNode.parentId != null ? this.defaultUserNode.parentId : this.defaultUserNode.id;
        this.defaultExpandedKeys = [expandedId];
        sessionStorage.setItem("subjectNodes", JSON.stringify(this.defaultUserNode));

        // 检查学科名称是否被截断
        this.checkSubjectNameTruncation();

        if (this.treeData.length > 0 && this.open) {
          this.defaultCheckedNodes();
        }
      });
    },
    findNodeById(tree, targetId) {
      // 遍历当前层级的每个节点
      for (let node of tree) {
        // 如果找到目标节点，直接返回
        if (node.id === targetId) {
          return node;
        }

        // 如果当前节点有子节点，递归查找子节点
        if (node.childrenList && node.childrenList.length > 0) {
          const found = this.findNodeById(node.childrenList, targetId);
          // 如果在子节点中找到，返回结果
          if (found) {
            return found;
          }
        }
      }
      // 遍历完所有节点都没找到，返回null
      return null;
    },
    showDialog() {
      this.open = true;
      this.searchTreeFlag = false;
      this.getSubjectAgo();
    },
    defaultCheckedNodes() {
      this.$nextTick(() => {
        // 假设我们要默认选中第一个父节点下的第一个子节点
        // const firstParentId = this.treeData[0].id;

        if (!this.defaultUserNode) {
          this.currentNodeKey = this.treeData[0].childrenList[0];
          this.$refs.tree.setCheckedNodes([this.currentNodeKey]);
        } else {
          this.currentNodeKey = this.defaultUserNode;
          this.$refs.tree.setCheckedNodes([this.currentNodeKey]);
        }
        this.defaultCheckedName = this.currentNodeKey.label;
      });
    },
    changeCn(val) {
      this.cnFlag = val;
      sessionStorage.setItem("cnFlag", this.cnFlag);
      this.updateTreeCn();
    },
    updateTreeCn() {
      this.treeData.forEach(element => {
        this.$set(element, "label", this.cnFlag ? element.cnName : element.name);
        // 一级学科禁用勾选
        this.$set(element, "disabled", true);
        if (element.childrenList && element.childrenList.length > 0) {
          element.childrenList.forEach(item => {
            this.$set(item, "label", this.cnFlag ? item.cnName : item.name);
            // 二级学科允许勾选
            this.$set(item, "disabled", false);
          });
        }
      });
      // 处理直接切换中英文，修改缓存里的数据

      let currentNodes = this.defaultUserNode;

      currentNodes.label = this.cnFlag ? currentNodes.cnName : currentNodes.name;

      this.defaultCheckedName = currentNodes.label;

      // 切换中英文时，通知其他组件更新，但始终传递英文名称作为接口参数
      EventBus.$emit("SubjectName", currentNodes.name);

      // 检查学科名称是否被截断
      this.checkSubjectNameTruncation();
    },
    handleNodeClick(data) {
      // 如果是一级学科（有子节点），不允许选择
      if (data.childrenList && data.childrenList.length > 0) {
        return;
      }

      // 如果已经选中了一个节点，则取消选择
      if (this.currentNodeKey?.name && this.$refs.tree) {
        this.$refs.tree.setCheckedKeys([]);
        // 更新当前选中节点的 key
        this.$refs.tree.setCheckedNodes([data]);
        sessionStorage.setItem("subjectNodes", JSON.stringify(data));
        this.defaultCheckedName = data.label;
        this.defaultCheckedId = data.id;
        EventBus.$emit("submitSubject", this.defaultCheckedId);
        EventBus.$emit("SubjectName", data.name);
        this.open = false;

        // 检查学科名称是否被截断
        this.checkSubjectNameTruncation();
      }

      // 更新当前选中节点的 key
      this.currentNodeKey = data;
      this.saveSubjectNode(data.id);
    },
    saveSubjectNode(id) {
      this.$http({
        url: "api/v1/subject/gateway/click/add?subjectId=" + id,
        method: "GET",
      }).then(res => {});
    },
    // 点击行即可让复选框勾选
    handleRowClick(data) {
      // 如果还有子级  就不执行后续操作，只需要展开
      if (data.childrenList.length > 0) {
        return;
      }

      this.handleNodeClick(data);
    },
    toHome() {
      window.open(`/`);
    },
    toRouter(index) {
      this.tabIndex = index;
      if (index == 1) {
        this.$router.push({
          path: "/subjectGateway/index",
        });
      }
      if (index == 2) {
        this.$router.push({
          path: "/subjectGateway/journal",
        });
      }
      if (index == 3) {
        this.$router.push({
          path: "/subjectGateway/news",
        });
      }
      if (index == 4) {
        this.$router.push({
          path: "/subjectGateway/author",
        });
      }
      if (index == 5) {
        this.$router.push({
          path: "/subjectGateway/topic",
        });
      }
      if (index == 6) {
        this.$router.push({
          path: "/subjectGateway/literature",
        });
      }
      if (index == 7) {
        this.$router.push({
          path: "/subjectGateway/dynamic",
        });
      }
    },
    toMine() {
      if (this.info.ipUser) {
        this.$router.push({
          path: "/lg?word=true&asp=true",
          query: { ipFrom: true },
        });
        return;
      }
      window.open(`/asp/self_setting?openFlag=true&self=true`, "_blank");
    },
    toLogin() {
      window.open(`/lg?word=true`, "_blank");
    },
    // 处理学科检索功能
    handleSubjectSearch() {
      if (!this.subjectSearchKeyword.trim()) {
        this.$message.warning("请输入检索词");
        return;
      }

      // 保存检索关键词到sessionStorage
      sessionStorage.setItem("subjectSearchKeyword", this.subjectSearchKeyword.trim());

      // 获取当前选中的学科信息
      const currentSubject = sessionStorage.getItem("subjectNodes") ? JSON.parse(sessionStorage.getItem("subjectNodes")) : null;

      // 保存学科检索相关信息到sessionStorage
      const subjectSearchInfo = {
        keyword: this.subjectSearchKeyword.trim(),
        subjectId: currentSubject ? currentSubject.id : null,
        subjectName: currentSubject ? currentSubject.name : null,
      };
      sessionStorage.setItem("subjectSearchInfo", JSON.stringify(subjectSearchInfo));

      window.open("/article", "_blank");
    },
    // 清空学科检索关键词
    clearSubjectSearch() {
      this.subjectSearchKeyword = "";
      // 同时清除sessionStorage中的关键词
      sessionStorage.removeItem("subjectSearchKeyword");
      sessionStorage.removeItem("subjectSearchInfo");
    },
    // 检查学科名称是否被截断,用于学科名称过长时显示省略号
    checkSubjectNameTruncation() {
      this.$nextTick(() => {
        const subjectNameEl = this.$refs.subjectName;
        if (subjectNameEl) {
          this.isSubjectNameTruncated = subjectNameEl.scrollWidth > subjectNameEl.clientWidth;
        }
      });
    },
    getKeywordData() {
      // 根据当前激活的tab选择对应的关键词
      if (!this.subjectSearchKeyword.trim()) {
        this.searchFlag = false;
        return;
      }
      let postBody = {
        word: this.subjectSearchKeyword.trim(),
      };
      this.$http({
        url: `api/v1/user/literature/suggestion`,
        method: "post",
        data: postBody,
      }).then(res => {
        if (res.code == 200) {
          if (res.data.length == 0) {
            this.searchFlag = false;
          } else {
            this.keywordDataList = res.data;
            this.searchFlag = true;
          }
        }
      });
    },

    // 点击联想关键词事件
    toSearchKeyword(index) {
      sessionStorage.removeItem("subjectSearchKeyword");
      let searchWords = this.keywordDataList[index].suggestionWord.split("<span style='color:#15babc'>").join("").split("</span>").join("");
      sessionStorage.setItem("subjectSearchKeyword", searchWords);
      // 获取当前选中的学科信息
      const currentSubject = sessionStorage.getItem("subjectNodes") ? JSON.parse(sessionStorage.getItem("subjectNodes")) : null;

      // 保存学科检索相关信息到sessionStorage
      const subjectSearchInfo = {
        keyword: searchWords,
        subjectId: currentSubject ? currentSubject.id : null,
        subjectName: currentSubject ? currentSubject.name : null,
      };
      sessionStorage.setItem("subjectSearchInfo", JSON.stringify(subjectSearchInfo));
      this.subjectSearchKeyword = "";
      window.open("/article", "_blank");
      this.searchFlag = false;
    },

    // 控制联想框显示
    showSearchInput() {
      if (this.subjectSearchKeyword.trim() && this.keywordDataList.length > 0) {
        this.searchFlag = true;
      }
    },

    // 控制联想框隐藏
    hideSearchInput() {
      // 使用setTimeout延迟隐藏，以便点击联想词时能触发点击事件
      setTimeout(() => {
        this.searchFlag = false;
      }, 200);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
::v-deep .el-input-group__append {
  background: #63ace5;
  i {
    color: #fff;
  }
}
.change-cn {
  margin-bottom: 20px;

  .el-input {
    margin-top: 20px;
    flex: 1;
  }
}

.dialog-tree {
  max-height: min(60vh, 560px);
  overflow: auto;

  // 一级学科仅用于展开分组，不显示禁用状态的选择框。
  ::v-deep .el-tree > .el-tree-node > .el-tree-node__content > .el-checkbox {
    display: none;
  }

  ::v-deep .el-tree-node__content {
    min-width: 0;
  }

  ::v-deep .el-tree-node__label {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

.search-section {
  background: #f8f9fa;
  padding: 15px 0;
  border-bottom: 1px solid #e9ecef;

  .container {
    width: 1300px;
    max-width: 1300px;
    margin: 0 auto;

    .search-box {
      display: flex;
      justify-content: center;

      .search-input {
        width: 500px;
        max-width: 500px;

        ::v-deep .el-input__inner {
          border-radius: 25px;
          border: 1px solid #dcdfe6;
          padding-left: 20px;
          padding-right: 45px;
          font-size: 14px;
          transition: all 0.3s ease;

          &:focus {
            border-color: #63ace5;
            box-shadow: 0 0 0 2px rgba(99, 172, 229, 0.2);
          }
        }

        .search-icon {
          color: #63ace5;
          cursor: pointer;
          font-size: 16px;
          transition: all 0.3s ease;

          &:hover {
            color: #4a90c2;
            transform: scale(1.1);
          }
        }
      }
    }
  }
}
::v-deep .el-input__inner:focus {
  border-color: #63ace5;
}
::v-deep .el-dialog__body {
  padding: 10px 20px;
  padding-bottom: 20px;
}
::v-deep .el-checkbox__input.is-checked .el-checkbox__inner {
  background-color: #63ace5;
  border-color: #63ace5;
}
::v-deep .el-switch.is-checked .el-switch__core {
  background-color: #63ace5;
  border-color: #63ace5;
}
::v-deep .el-switch__label.is-active {
  color: #63ace5;
}
header {
  .header-container {
    background-image: linear-gradient(to right, #1a3c5f, #2c5f97);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    height: 100px;
    color: #fff;
    display: flex;
    align-items: center;
    .header-main {
      width: 1300px;
      max-width: 1300px;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      align-items: center;
      flex-wrap: wrap;
    }
  }
  .user-controls {
    display: flex;
    gap: 10px;
    align-items: center;

    .search-and-subject {
      display: flex;
      align-items: center;
      gap: 10px;

      .subject-search-box {
        .subject-search-input {
          width: 400px; // 可以根据需要调整，比如 120px, 180px, 250px 等

          ::v-deep .el-input__inner {
            background: rgba(255, 255, 255, 0.2);
            border: 1px solid rgba(255, 255, 255, 0.4);
            border-radius: 25px;
            color: #fff;
            font-size: 14px;
            font-weight: 500;
            padding-left: 20px;
            padding-right: 70px; // 增加右侧内边距，为两个图标预留空间
            height: 40px;
            line-height: 40px;

            &::placeholder {
              color: rgba(255, 255, 255, 0.7);
            }

            &:focus {
              background: rgba(255, 255, 255, 0.25);
              border-color: rgba(255, 255, 255, 0.6);
              box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.2);
            }

            &:hover {
              background: rgba(255, 255, 255, 0.25);
              border-color: rgba(255, 255, 255, 0.5);
            }
          }

          ::v-deep .el-input__suffix {
            right: 15px; // 调整后缀区域的位置

            .el-input__suffix-inner {
              align-items: center;
              gap: 5px; // 减少图标间距，确保在有限空间内显示
            }

            .el-input__icon {
              color: rgba(255, 255, 255, 0.8);
              cursor: pointer;
              font-size: 16px;
              transition: all 0.3s ease;
              flex-shrink: 0; // 防止图标被压缩

              &:hover {
                color: #fff;
                transform: scale(1.1);
              }
            }

            .clear-icon {
              color: rgba(255, 255, 255, 0.6);

              &:hover {
                color: #ff6b6b; // 悬浮时显示红色，表示删除操作
                transform: scale(1.15);
              }
            }

            .search-icon {
              &:hover {
                color: #fff;
                transform: scale(1.1);
              }
            }
          }
        }
      }
    }
  }
  .subject-selector {
    border: none;
    border-radius: 25px;
    padding: 10px 20px;
    color: white;
    font-weight: 500;
    display: flex;
    align-items: center;
    gap: 10px;
    cursor: pointer;
    transition: all 0.3s ease;
    max-width: 300px;
    min-width: 180px;
    position: relative;
    height: 40px;
    box-sizing: border-box;
    background: #e7eff6;
    color: #555;
    .subject-name {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      flex: 1;
      min-width: 0;
    }

    .subject-btn {
      flex-shrink: 0;
      i {
        margin-right: 5px;
      }
    }

    &:hover {
      background: #e6f7ff;
    }
  }
  .user-profile {
    display: flex;
    align-items: center;
    background: rgba(255, 255, 255, 0.15);
    padding: 5px 15px;
    border-radius: 50px;
    cursor: pointer;
    i {
      margin-right: 5px;
    }
  }
  .subject-nav {
    background: white;
    border-radius: 0 0 15px 15px;
    padding: 15px 0;
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.08);
    .container {
      width: calc(100% - 40px);
      max-width: 1300px;
      min-width: 0;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      align-items: center;
      gap: 16px;
      .subject-tabs {
        display: flex;
        flex: 1 1 auto;
        min-width: 0;
        gap: 5px;
        overflow-x: auto;

        .subject-tab {
          padding: 10px 25px;
          border-radius: 50px;
          background: #e7eff6;
          color: #555;
          font-weight: 500;
          white-space: nowrap;
          cursor: pointer;
          transition: all 0.3s ease;
        }
        .checked {
          background: #e6f7ff;
          color: #2c5f97;
        }
      }
    }
  }
}

@media (max-width: 1100px) {
  header .subject-nav .container {
    align-items: stretch;
    flex-wrap: wrap;

    .subject-tabs {
      flex-basis: 100%;
    }

    .subject-selector {
      width: 100%;
      max-width: none;
    }
  }
}

@media (max-width: 768px) {
  header .subject-nav {
    padding: 10px 0;

    .container {
      width: calc(100% - 24px);
      gap: 10px;

      .subject-tabs .subject-tab {
        padding: 8px 14px;
      }

      .subject-selector {
        min-width: 0;
        padding: 8px 12px;
      }
    }
  }

  ::v-deep .subject-dialog {
    margin-top: 5vh !important;

    .el-dialog__body {
      padding: 10px 12px 16px;
    }
  }

  .change-cn .el-input {
    margin-top: 12px;
  }
}

.search-lianxiang {
  position: absolute;
  top: 70px;
  margin-left: 20px;
  width: 360px;
  max-height: 300px;
  overflow-y: auto;
  background: white;
  border: 1px solid #ddd;
  border-top: none;
  border-radius: 0 0 4px 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  ul {
    margin: 0;
    padding: 0;
    li {
      padding: 6px 16px;
      cursor: pointer;
      transition: background-color 0.2s;
      color: #666;
      font-size: 15px;
      &:hover {
        background-color: #f5f7fa;
      }
    }
  }
}
.ip-warning {
  color: red;
  padding: 8px 0;
  text-align: center;
  font-size: 14px;
  /* font-weight: bold; */
  position: absolute;
  margin-left: 1080px;
  margin-top: 60px;
}
</style>
